module.exports = __webpack_public_path__ + "static/media/1.26d66786.png";